import React from 'react';
import styled from '@emotion/styled';
import { AtlassianLogo, ConfluenceLogo } from '@atlaskit/logo';

import { CobrandingComponents } from '../shared-cobranding';
import { colors, gridSize } from '@atlaskit/theme';

const LogoWrapper = styled.div({
  textAlign: 'center',
});

const Container = styled.div({
  '#ProductHeadingSuffix h2': {
    color: colors.N800,
    marginTop: `${gridSize() * 3}px`,
    fontSize: '2.4em',
  },
});

function BlankBackgroundWithLogo({ children }: { children: React.ReactNode }) {
  return (
    <Container>
      {children}
      <LogoWrapper>
        <AtlassianLogo appearance="brand" size="small" />
      </LogoWrapper>
    </Container>
  );
}

const WacSignupOTPExperimentConfluence: CobrandingComponents = {
  background: BlankBackgroundWithLogo,
  logo: { component: ConfluenceLogo },
  whiteboxWidth: '460px',
  hideWhiteboxBorder: true,
};

export default WacSignupOTPExperimentConfluence;
